/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Node_ShowroomInputs */

const en_node_showroom = /** @type {(inputs: Node_ShowroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Showroom`)
};

/**
* | output |
* | --- |
* | "Showroom" |
*
* @param {Node_ShowroomInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const node_showroom = /** @type {((inputs?: Node_ShowroomInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Node_ShowroomInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_node_showroom(inputs)
});